var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-footer"},[_c('div',{staticClass:"h-footerIn"},[_c('p',[_vm._v("Copyright Haier 2019. All rights reserved")])])])
}]

export { render, staticRenderFns }